var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import classnames from 'classnames';
import userStorage from '@/shared/services/userStorage';
var storageKey = 'sidebarCollapsed';
var CollapsableSidebar = function (_a) {
    var children = _a.children;
    var _b = useState(userStorage.getItem(storageKey) || false), isCollapsed = _b[0], setCollapsed = _b[1];
    var _c = useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var sidebar = children[0], mainView = children[1];
    useEffect(function () {
        setIsLoading(false);
    }, []);
    useEffect(function () {
        userStorage.setItem(storageKey, isCollapsed);
    }, [isCollapsed]);
    return (_jsxs("div", __assign({ className: classnames('sidebar-wrapper', {
            'sidebar-collapsed': isCollapsed,
            'sidebar-loading': isLoading,
        }) }, { children: [_jsx("div", __assign({ className: "sidebar" }, { children: sidebar })), _jsx("div", __assign({ className: "gap" }, { children: _jsx("a", __assign({ onClick: function () { return setCollapsed(function (x) { return !x; }); }, className: "sidebar-toggle" }, { children: _jsx("i", { className: classnames('fa ', isCollapsed ? 'fa-chevron-circle-right' : 'fa-chevron-circle-left') }) })) })), _jsx("div", __assign({ className: "mainview" }, { children: mainView }))] })));
};
export default CollapsableSidebar;
